// Romanian search terms -> English catalog vocabulary.
// Product titles are English ("Hoodie", "Windbreaker"), and Shopify's search
// matches Romanian words like "hanorac" only through descriptions, so it
// returns jackets and shirts. Known Romanian words are rewritten into an
// English OR-query before the request; the visitor still sees what they typed.
(function () {
  var GROUPS = {
    hoodie: 'hoodie OR sweater OR crewneck OR sweatshirt OR fleece',
    sweater: 'sweater OR crewneck',
    tshirt: 't-shirt OR tee',
    shirt: 'shirt NOT t-shirt NOT tee',
    jacket: 'windbreaker OR jacket OR bomber OR overcoat',
    pants: 'pants OR sweatpants OR jeans OR trousers',
    sweatpants: 'sweatpants OR training',
    jeans: 'jeans OR denim',
    shorts: 'shorts OR bermuda',
    hat: 'hat OR cap OR beanie',
  };

  // Keys are lowercase without diacritics.
  var WORDS = {
    hanorac: GROUPS.hoodie, hanorace: GROUPS.hoodie, hanoracul: GROUPS.hoodie, hanoracele: GROUPS.hoodie,
    bluza: GROUPS.hoodie, bluze: GROUPS.hoodie, bluzita: GROUPS.hoodie, gluga: 'hoodie',
    pulover: GROUPS.sweater, pulovere: GROUPS.sweater,
    tricou: GROUPS.tshirt, tricouri: GROUPS.tshirt, tricoul: GROUPS.tshirt, tricourile: GROUPS.tshirt,
    camasa: GROUPS.shirt, camasi: GROUPS.shirt, camasile: GROUPS.shirt, camasuta: GROUPS.shirt,
    geaca: GROUPS.jacket, geci: GROUPS.jacket, geaci: GROUPS.jacket, jacheta: GROUPS.jacket, jachete: GROUPS.jacket,
    palton: 'overcoat', paltoane: 'overcoat',
    pantaloni: GROUPS.pants, pantalon: GROUPS.pants,
    trening: GROUPS.sweatpants, treninguri: GROUPS.sweatpants,
    blugi: GROUPS.jeans,
    sort: GROUPS.shorts, sorturi: GROUPS.shorts, bermude: GROUPS.shorts, scurti: GROUPS.shorts,
    fusta: 'skirt', fuste: 'skirt', fustita: 'skirt',
    rochie: 'dress', rochii: 'dress', rochita: 'dress',
    sosete: 'socks', ciorapi: 'socks',
    compleu: 'set', compleuri: 'set', seturi: 'set',
    sapca: GROUPS.hat, palarie: GROUPS.hat, caciula: GROUPS.hat, caciuli: GROUPS.hat,
    cadou: 'gift', voucher: 'gift card',
    negru: 'black', negre: 'black', neagra: 'black', negri: 'black',
    alb: 'white', alba: 'white', albe: 'white', albi: 'white',
    gri: 'grey OR gray OR graphite',
    roz: 'pink', bej: 'beige', maro: 'brown', crem: 'ivory OR cream',
    albastru: 'blue', albastra: 'blue', albastre: 'blue', albastri: 'blue',
    verde: 'green', verzi: 'green', rosu: 'red', rosie: 'red', rosii: 'red',
    portocaliu: 'orange', mov: 'purple OR mauve',
    barbati: 'men', barbat: 'men', baieti: 'men',
    femei: 'women', femeie: 'women', dama: 'women', fete: 'women',
  };

  // Dropped only when another word was translated ("hanorac cu gluga").
  var STOPWORDS = ['de', 'cu', 'pentru', 'si', 'la', 'din', 'o', 'un', 'pt'];
  var PHRASES = [['pantaloni scurti', GROUPS.shorts], ['pantaloni de trening', GROUPS.sweatpants]];

  function normalize(text) {
    return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // A word still being typed ("hanor") matches every dictionary word it starts;
  // their English terms are OR-ed together ("blu" -> bluza + blugi).
  function completeWord(prefix) {
    if (prefix.length < 3) return null;
    var groups = [];
    Object.keys(WORDS).forEach(function (word) {
      if (word.indexOf(prefix) === 0 && groups.indexOf(WORDS[word]) === -1) groups.push(WORDS[word]);
    });
    if (groups.length < 2) return groups[0] || null;
    var terms = [];
    groups.forEach(function (group) {
      group.split(' NOT ')[0].split(' OR ').forEach(function (english) {
        if (terms.indexOf(english) === -1) terms.push(english);
      });
    });
    return terms.length ? terms.join(' OR ') : null;
  }

  // Returns the rewritten query, or null when nothing was translated.
  function expand(term) {
    if (!term || /\s(OR|NOT|AND)\s/.test(term)) return null;
    var text = normalize(term);
    var groups = [];
    var translated = false;
    var typing = !/\s$/.test(term);
    if (typing) {
      // "pantaloni scu" while typing "pantaloni scurti".
      PHRASES.forEach(function (phrase) {
        var start = text.lastIndexOf(phrase[0].split(' ')[0] + ' ');
        if (start === -1) return;
        var tail = text.slice(start);
        var lastWord = tail.split(' ').pop();
        if (lastWord && STOPWORDS.indexOf(lastWord) === -1 && phrase[0].indexOf(tail) === 0) {
          text = text.slice(0, start) + phrase[0];
        }
      });
    }
    PHRASES.forEach(function (phrase) {
      if (text.indexOf(phrase[0]) === -1) return;
      text = text.replace(phrase[0], ' ');
      groups.push(phrase[1]);
      translated = true;
    });
    var rest = [];
    var words = text.split(' ');
    words.forEach(function (word, index) {
      if (!word) return;
      var match = WORDS[word] || (typing && index === words.length - 1 && completeWord(word));
      if (match) {
        groups.push(match);
        translated = true;
      } else {
        rest.push(word);
      }
    });
    if (!translated) return null;
    rest.forEach(function (word) {
      if (STOPWORDS.indexOf(word) === -1) groups.push(word);
    });
    if (groups.length === 1) return groups[0];
    return groups.map(function (group) { return / (OR|NOT) /.test(group) ? '(' + group + ')' : group; }).join(' ');
  }

  window.searchSynonyms = { expand: expand };

  function isSearchPath(pathname) {
    return /\/search\/?$/.test(pathname);
  }

  // Full search: send the rewritten query and keep the typed one in "rq" so
  // the results page can show it. Runs after the form's own submit handlers
  // (predictive search cancels the submit when a result is highlighted).
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form.action || !isSearchPath(new URL(form.action, location.href).pathname)) return;
    var input = form.querySelector('input[name="q"]');
    var expanded = input && expand(input.value);
    if (!expanded) return;
    event.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    params.set('q', expanded);
    params.set('rq', input.value.trim());
    location.href = form.action + '?' + params.toString();
  });

  function onSearchPage() {
    if (!isSearchPath(location.pathname)) return;
    var params = new URLSearchParams(location.search);
    var q = params.get('q') || '';
    var rq = params.get('rq');

    // Results are products only: without type=product Shopify also lists pages and blog posts.
    var needsType = q && !params.get('type');
    if (needsType) params.set('type', 'product');

    // Links straight to /search?q=hanorac (popular-search pills, shared links).
    if (!rq) {
      var expanded = expand(q);
      if (expanded) {
        params.set('q', expanded);
        params.set('rq', q.trim());
      }
      if (expanded || needsType) location.replace(location.pathname + '?' + params.toString());
      return;
    }
    if (needsType) {
      location.replace(location.pathname + '?' + params.toString());
      return;
    }

    // Show the typed words instead of the OR-query. Hidden q inputs (filters)
    // keep the rewritten query.
    document.querySelectorAll('input[type="search"][name="q"]').forEach(function (input) {
      if (input.value === q) input.value = rq;
    });
    // Pagination and sorting links keep "rq" so later pages show it too.
    document.querySelectorAll('a[href*="q="]').forEach(function (link) {
      var url = new URL(link.href, location.href);
      if (!isSearchPath(url.pathname) || url.searchParams.get('q') !== q) return;
      url.searchParams.set('rq', rq);
      link.href = url.toString();
    });
    var walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf(q) !== -1) node.nodeValue = node.nodeValue.split(q).join(rq);
    }
    if (document.title.indexOf(q) !== -1) document.title = document.title.split(q).join(rq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onSearchPage);
  } else {
    onSearchPage();
  }
})();
